export default {
  default: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/layouts/default.vue").then(m => m.default || m)
}